import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { activateUser, defaultActivationValues } from 'src/app/components/users/activate-user';
import { LoginService } from 'src/app/services/login.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-activate-user',
    templateUrl: './activate-user.component.html',
    styleUrls: ['./activate-user.component.scss'],
    standalone: false
})
export class ActivateUserComponent {
  activationDetailsUser: activateUser = defaultActivationValues()
  userEmail = "";
  confirmPassword: string = "";
  constructor(
    private _userservice: UserService, 
    private _toastservice: ToastService, 
    private router: Router, 
    private _route: ActivatedRoute
    ) { }

  activateRA(af: NgForm) {
    if (af.invalid) {
      Object.values(af.controls).forEach(control => control.markAllAsTouched());
      return;
    }
    if (this.activationDetailsUser.password != this.confirmPassword) {
      return;
    }
    this._userservice.activateUser(this.activationDetailsUser).subscribe({
      next: (response) => {
        this._toastservice.showMessage("Account is activated. Please login in to the portal");
        this.router.navigate(['/bb-login']);
      },
      error: (err) => { }
    })
  }

  ngOnInit(): void {
    this._route.params.subscribe(param => {
      this.activationDetailsUser.activationGuid = decodeURIComponent(param['guid']); 
      this._userservice.getUserDetailsFromGuid(this.activationDetailsUser.activationGuid).subscribe({
        next:(resp)=>{
          this.userEmail = resp.username
        }
      })
    
    }
    );
  }
}
